/*
 * ArchiveButton Messages
 *
 * This contains all the text for the ArchiveButton component.
 */

import { defineMessages } from 'react-intl';
const scope = 'src.pages.ContractsPage.components.ArchiveButton';

export default defineMessages({
  archiveButton: {
    id: `${scope}.archiveButton`,
    defaultMessage: 'Archive',
  },
  archiveConfirmMessage: {
    id: `${scope}.archiveConfirmMessage`,
    defaultMessage:
      'Are you sure you want to archive the contracts in this file?',
  },
});
